import { render, staticRenderFns } from "./AbonentMemo.vue?vue&type=template&id=cd28f6c2&scoped=true&"
import script from "./AbonentMemo.vue?vue&type=script&lang=js&"
export * from "./AbonentMemo.vue?vue&type=script&lang=js&"
import style0 from "./AbonentMemo.vue?vue&type=style&index=0&id=cd28f6c2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd28f6c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VTextarea,VToolbar,VToolbarTitle})
